import React, { useContext, useEffect, useState } from "react";
import {} from "./styled";
import DashboardCardTabs from "components/Dashboard/Cards/Tabs";
import DashboardCardTable from "components/Dashboard/Cards/Table";
import { useHistory } from "react-router-dom";
import { ContentTableAction, ContentTableActionIconRemove } from "ui/styled";
import Button from "components/Form/Button";
import { CoreContext } from "context/CoreContext";
import { ReadAll } from "services/event";
import {
  exposeStrapiError,
  normalizeStrapiList,
  typeSheetOptions,
} from "utils";
import Select from "components/Form/Select";

export default function DashboardListsEvents() {
  const history = useHistory();
  const navigate = (to) => history.push(`/${to}`);
  const { searchExpression, currentCompany } = useContext(CoreContext);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sheetTypes, setSheetTypes] = useState([]);
  const [selectedSheetType, setSelectedSheetType] = useState(""); // Inicializa vazio

  const columns = [
    { title: "Evento", ref: "event" },
    { title: "Código", ref: "code" },
    { title: "Mostrar no Dashboard", ref: "isDashboard" },
    { title: "Tipo de folha", ref: "sheetType" },
    {
      title: " ",
      renderCell: ({ row }) => (
        <ContentTableAction>
          <Button
            primary
            nospace
            small
            onClick={() => navigate(`dashboard/events/add/${row.id}`)}
          >
            <ContentTableActionIconRemove />
          </Button>
        </ContentTableAction>
      ),
    },
  ];

  const getSheetTitleById = (id) => {
    return (
      typeSheetOptions.find((option) => option.id === id)?.title ||
      "Desconhecido"
    );
  };

  const parseRegister = (item) => ({
    ...item,
    event: item.name,
    code: item.code,
    isDashboard: item.is_dashboard ? "Sim" : "Não",
    sheetType: getSheetTitleById(item.sheetType), // Convertendo ID para título na exibição
    _raw: item, // Mantém os dados brutos para comparação no filtro
  });

  const init = async () => {
    setLoading(true);

    try {
      const result = await ReadAll(currentCompany?.id);

      if (result && !exposeStrapiError(result)) {
        const normalizedResult = normalizeStrapiList(result) || [];

        setRows(normalizedResult.map(parseRegister));

        // Buscar apenas os tipos de folha presentes nos eventos
        const distinctSheetTypes = Array.from(
          new Set(normalizedResult.map((item) => item.sheetType))
        ).map((type) => ({
          id: type,
          title: getSheetTitleById(type),
        }));

        setSheetTypes(distinctSheetTypes);

        // **Definir automaticamente o tipo compatível com currentCompany?.typeSheet**
        const initialSheetType = distinctSheetTypes.find(
          (option) => option.id === currentCompany?.typeSheet
        )?.id;

        if (initialSheetType) {
          setSelectedSheetType(initialSheetType);
        }
      } else {
        setRows([]);
        setSheetTypes([]);
      }
    } catch (error) {
      console.error("Erro ao buscar eventos:", error);
      setRows([]);
      setSheetTypes([]);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (currentCompany?.id) {
      init();
    }
  }, [currentCompany]);

  // Atualiza automaticamente quando `sheetTypes` for carregado
  useEffect(() => {
    if (sheetTypes.length > 0 && selectedSheetType === "") {
      const initialSheetType = sheetTypes.find(
        (option) => option.id === currentCompany?.typeSheet
      )?.id;
      if (initialSheetType) {
        setSelectedSheetType(initialSheetType);
      }
    }
  }, [sheetTypes, currentCompany]);

  const handleSelectChange = (value) => {
    setSelectedSheetType(value);
  };

  const filterExpression = (item) => {
    const matchSearch =
      !searchExpression ||
      Object.values(item).some((v) =>
        `${v}`.toLowerCase().includes(searchExpression.toLowerCase())
      );

    const matchSheetType = item._raw.sheetType === selectedSheetType;

    return matchSearch && matchSheetType;
  };

  return (
    <>
      <DashboardCardTabs
        title={"Lista de eventos"}
        selectable={{ placeholder: "Ações" }}
      >
        <div style={{ width: 300, marginBottom: 12, marginTop: 12 }}>
          <Select
            id="sheetType-filter"
            placeholder="Filtrar por tipo de folha"
            options={sheetTypes}
            value={selectedSheetType}
            onChange={handleSelectChange}
          />
        </div>

        <DashboardCardTable
          rows={rows.filter(filterExpression)}
          columns={columns}
          searchExpression={searchExpression}
          pagination
          loading={loading}
        />
      </DashboardCardTabs>
    </>
  );
}
